import { Button, Form, Modal } from 'antd';
import React, { useState } from 'react';
import { ICON } from './icon';
import EditorPrivacy from '../../../../components/Shared/forms/EditorPrivacy';
import { useTranslation } from 'react-i18next';

export default function Confirmation({ formMain }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handelOpen = () => {
        const certificateTh = formMain.getFieldValue([
            'customizeForm',
            'certificate',
            'certificateTh',
        ]);

        const certificateEn = formMain.getFieldValue([
            'customizeForm',
            'certificate',
            'certificateEn',
        ]);

        setTimeout(() => {
            form.setFieldsValue({
                certificateTh,
                certificateEn:
                    certificateEn === '<p>-</p>' ? '' : certificateEn,
            });
        }, 100);
        setIsModalOpen(true);
    };

    const onFinish = () => {
        setIsModalOpen(false);
        formMain.setFieldsValue({
            customizeForm: {
                certificate: {
                    certificateTh: form.getFieldValue('certificateTh'),
                    certificateEn: form.getFieldValue('certificateEn') || '-',
                },
            },
        });
    };

    const handelClose = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <button
                className="z-10 absolute right-4 flex items-center gap-2 text-[#1890FF] font-semibold"
                type="button"
                onClick={handelOpen}
            >
                {ICON.Edit} {t('Edit')}
            </button>
            <Modal
                centered
                width="50%"
                className="_modal"
                title={t('Certificate')}
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={false}
            >
                <Form onFinish={onFinish} form={form} layout="vertical">
                    <Form.Item
                        name="certificateTh"
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('Thai')}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <EditorPrivacy
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                    <Form.Item
                        name="certificateEn"
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('English')}
                            </span>
                        }
                    >
                        <EditorPrivacy
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                    <div className="mt-9 flex justify-center space-x-3">
                        <Button
                            onClick={handelClose}
                            className="min-w-[120px] border-[#7B67FB] text-[#7B67FB]"
                            size="large"
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            className="min-w-[120px]"
                            size="large"
                            type="primary"
                            htmlType="submit"
                        >
                            {t('common.Confirm')}
                        </Button>
                    </div>
                </Form>
            </Modal>
        </>
    );
}
